// Provides logged in user context and permission shared functionality

import {
    ROLE_ACCOUNT_MGR,
    ROLE_ACCOUNT_MGR_BILLING,
    ROLE_FINANCE,
    ROLE_PROJECT_MGR,
    ROLE_SITE_ADMIN,
    ROLE_SUPER_ADMIN
} from "../../common/constants";

export default {
    namespaced: true,
        state: {
            account: {
                id: auth.usergroup,
                name: auth.company
            },
            user: {
                id: auth.id,
                fullName: `${auth.firstname} ${auth.lastname}`,
                isConfidential: auth.is_confidential
            },
            role: auth.role,
            accountManagerUserRoles: [
            ROLE_ACCOUNT_MGR_BILLING,
            ROLE_ACCOUNT_MGR
            ],
            adminViewUserRoles: [
            ROLE_SUPER_ADMIN,
            ROLE_SITE_ADMIN,
            ROLE_PROJECT_MGR,
            ROLE_FINANCE
            ],
            siteAdmins: [
             ROLE_SUPER_ADMIN,
             ROLE_SITE_ADMIN,
            ]
    },
    getters: {
        isAdminUser: state => {
          return state.adminViewUserRoles.includes(state.role);
        },
        isSiteAdminUser: state => {
            return state.siteAdmins.includes(state.role);
        },
        isAccountManagerRole: state => {
            return state.accountManagerUserRoles.includes(state.role);
        },
        isConfidentialUser: state => {
           return state.user.isConfidential;
        }
    },
    actions: {
        getSessionUser(){
            axios.get('/me').then(
                data => {
                    // todo define mutations
                }
            )
        }
    }
};
